const initialUserState = {
  loggedIn: false,
  loaded: false,
  loading: false,
};

export function userState(state = initialUserState, action) {
  switch (action.type) {
  case "SET_API_TOKENS": {
    let loggedIn = false;

    if (action.payload && action.payload.auth0 && action.payload.auth0.isAuthenticated) {
      loggedIn = true;
    }

    return { ...state, loggedIn };
  }
  case "LOGOUT_USER":
    return initialUserState;
  case "USER_DATA_LOADED":
    return { ...state, loaded: true, loading: false };
  case "USER_DATA_LOADING":
    return { ...state, loading: true, loaded: false };
  case "USER_DATA_LOAD_FAILED":
    return { ...state, loading: false, loaded: false };
  case "USER_UNAVAILABLE":
    return { ...state, loading: false, loaded: false, userUnavailable: true };
  default:
    return state;
  }

};

const initialUserRole = {
  id: "",
  notificationDelay: parseInt(process.env.CHECK_ENTRIES_DAY_INTERVAL, 10),
};

export function userRole(state = initialUserRole, action) {
  switch (action.type) {
  case "SET_USER_ROLE":
    return { ...state, ...action.role };
  case "LOGOUT_USER":
    return initialUserRole;
  default:
    return state;
  }
};

export default function user(state = {}, action) {
  switch (action.type) {
  case "SET_USER":
    return action.payload;
  case "LOGOUT_USER":
    return {};
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/settings/user.js